module.exports = __webpack_public_path__ + "static/studioemi-00e84426d0a2e96f5b9ec18fa2dfa680.svg";